module.exports = __webpack_public_path__ + "img/配套-01.b2da6e42.png";